import React, { useState, useEffect, useMemo } from 'react';
import { oneKlicks } from '../../../../SDK/oneclick';
import { getdoctorspecialities, getuserdata } from '../../../../services/apiService';

// Stable default specialities used when data is not updated
const DEFAULT_SPECIALITIES = [
    { speciality_name: { name: 'General Medicine' }, service_name: { name: 'General Medicine' } },
    { speciality_name: { name: 'Pediatrics' }, service_name: { name: 'Pediatrics' } },
    { speciality_name: { name: 'Dermatology' }, service_name: { name: 'Dermatology' } },
    { speciality_name: { name: 'Cardiology' }, service_name: { name: 'Cardiology' } },
    { speciality_name: { name: 'Orthopedics' }, service_name: { name: 'Orthopedics' } }
];

const DoctorSpecialities = ({ doctorId, service = false, data = [], blog = false }) => {
    console.log('DoctorSpecialities new data', data);
    const [specialities, setSpecialities] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAll, setShowAll] = useState(false);

    // Determine if we need to use defaults
    const isAllNotUpdated = useMemo(() => {
        return specialities.length === 0 || specialities.every(s => !s.service_name?.name || s.service_name?.name === 'Not Updated');
    }, [specialities]);

    // Pick a stable default list (3 items) once per doctorId
    const stableDefaultList = useMemo(() => {
        const shuffled = [...DEFAULT_SPECIALITIES].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 3);
    }, [doctorId]);

    // Pick a stable default main speciality once per doctorId
    const stableDefaultMain = useMemo(() => {
        const shuffled = [...DEFAULT_SPECIALITIES].sort(() => 0.5 - Math.random());
        return shuffled[0];
    }, [doctorId]);

    // Pick a stable list for tipso (+2) once per doctorId
    const stableTipsoDefaults = useMemo(() => {
        const shuffled = [...DEFAULT_SPECIALITIES].sort(() => 0.5 - Math.random());
        return shuffled.slice(1, 3);
    }, [doctorId]);

    useEffect(() => {
        const processData = async () => {
            try {
                if (data && Object.keys(data).length > 0) {
                    if (data.doctor_specialities && data.doctor_specialities.length > 0) {
                        console.log('DoctorSpecialities doctor_specialities data', data.doctor_specialities);
                        // Transform the data to match the expected format
                        const transformedSpecialities = data.doctor_specialities.map(item => ({
                            speciality_name: item.specialities[0] || { name: 'Not Updated' },
                            service_name: item.services[0] || { name: 'Not Updated' }
                        }));
                        console.log('Transformed specialities:', transformedSpecialities);
                        setSpecialities(transformedSpecialities);
                    } else if (data.speciality_ids) {
                        // Handle speciality_ids as JSON string
                        const parsedSpecialities = JSON.parse(data.speciality_ids);
                        console.log('DoctorSpecialities speciality_ids data', parsedSpecialities);
                        
                        // Convert object to array and map to required format
                        const specialitiesArray = Object.values(parsedSpecialities).map(speciality => ({
                            speciality_name: { name: speciality.name },
                            service_name: { name: speciality.name }
                        }));
                        console.log('Transformed speciality_ids:', specialitiesArray);
                        setSpecialities(specialitiesArray);
                    }
                } else {
                    console.log('DoctorSpecialities else data', data);
                    // await fetchDoctorSpecialities();
                }
            } catch (error) {
                console.error('Error processing data:', error);
                setError('Error processing data');
            } finally {
                setLoading(false);
            }
        };

        processData();
    }, [doctorId, data]);

 


    return (
        <div className="specialization">
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                <>  
                    {service ? (
                        <>
                        {/* Show first 3 specialities, if more than 3, show "+N more" button to expand/collapse */}
                        {(() => {
                            // Use stable defaults to avoid auto-changing on re-renders
                            const displaySpecialities = isAllNotUpdated ? stableDefaultList : specialities;
                            const visibleSpecialities = showAll ? displaySpecialities : displaySpecialities.slice(0, 3);
                            return (
                                <>
                                {/* add specialities in a list  incase Not Updated show some default specialities random */}
                                {displaySpecialities.length > 0 ? (
                                    <ul>
                                        {visibleSpecialities.map((speciality, index) => (
                                            <li key={index}>
                                                <a href="#">{speciality.service_name?.name || "Not Updated"}</a>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <ul>
                                        {stableDefaultList.map((speciality, index) => (
                                            <li key={index}>
                                                <a href="#">{speciality.service_name?.name}</a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {displaySpecialities.length > 3 && (
                                    <a
                                        href="#"
                                        className="dc-specilites-tipso dc-tipso tipso_style"
                                        onClick={e => {
                                            e.preventDefault();
                                            setShowAll(!showAll);
                                        }}
                                    >
                                        {showAll
                                            ? "Show Less"
                                            : `+${displaySpecialities.length - 3} more`}
                                        <i className={`fa fa-caret-${showAll ? "up" : "down"}`}></i>
                                    </a>
                                )}
                                </>
                            );
                        })()}
                        </>
                    ) : (
                        <>
                            {/* add specialities in a list  incase Not Updated show some default specialities random*/}
                            {(() => {
                                const allNotUpdated = specialities.length === 0 || specialities.every(s => !s.speciality_name?.name || s.speciality_name?.name === 'Not Updated');
                                const mainSpeciality = allNotUpdated ? stableDefaultMain : specialities[0];

                                return (
                                    <>
                                        <a href="#">{mainSpeciality?.speciality_name?.name || "Not Updated"}</a>
                                        {(specialities.length > 1 && !allNotUpdated) && (
                                            <a href="#" className="dc-specilites-tipso dc-tipso tipso_style" 
                                                data-tipso={Array.isArray(specialities) ? 
                                                    `<ul>${specialities.map(speciality => 
                                                        `<li><a href="#">${speciality.service_name?.name || 'Not Updated'}</a></li>`
                                                    ).join('')}</ul>` : ''} 
                                                data-id={doctorId}>
                                                    {specialities.length > 1 ? `+${specialities.length - 1}` : "Not Updated"}
                                                    <i className="fa fa-caret-down"></i>
                                            </a>
                                        )}
                                        {/* If all are Not Updated, show a random default tipso with 2-3 more */}
                                        {(allNotUpdated && specialities.length <= 1) && (
                                            <a href="#" className="dc-specilites-tipso dc-tipso tipso_style"
                                                data-tipso={`<ul>${stableTipsoDefaults.map(speciality =>
                                                    `<li><a href=\"#\">${speciality.service_name?.name}</a></li>`
                                                ).join('')}</ul>`}
                                                data-id={doctorId}
                                            >
                                                +2
                                                <i className="fa fa-caret-down"></i>
                                            </a>
                                        )}
                                    </>
                                );
                            })()}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default DoctorSpecialities;
